const ENDPOINT = 'POSTeditsong';
function postEditSong(gateway, params = {}) {
    return gateway.get(postEditSong.endpoint, params);
}
postEditSong.endpoint = ENDPOINT;

export { postEditSong as default };
//# sourceMappingURL=postEditSong.js.map
